import { camelCase, capitalCase, constantCase, dotCase, headerCase, noCase, paramCase, pascalCase, pathCase, sentenceCase, snakeCase, } from 'change-case';
import { titleCase } from 'title-case';
/**
 * Transform into a string with the separator denoted by the next word capitalized.
 * ```
 * toCamelCase("test string") //=> "testString"
 * ```
 **/
export const toCamelCase = (input) => camelCase(input);
// Backwards compatible alias
export const toCamelcase = toCamelCase;
/**
 * Transform into a space separated string with each word capitalized.
 * ```
 * toCapitalCase("test string") //=> "Test String"
 * ```
 **/
export const toCapitalCase = (input) => capitalCase(input);
// Backwards compatible alias
export const toTitleCaseBasic = toCapitalCase;
/**
 * Transform into upper case string with an underscore between words.
 * ```
 * toConstantCase("test string") //=> "TEST_STRING"
 * ```
 **/
export const toConstantCase = (input) => constantCase(input);
/**
 * Transform into a lower case string with a period between words.
 * ```
 * toDotCase("test string") //=> "test.string"
 * ```
 **/
export const toDotCase = (input) => dotCase(input);
/**
 * Transform into a dash separated string of capitalized words.
 * ```
 * toHeaderCase("test string") //=> "Test-String"
 * ```
 **/
export const toHeaderCase = (input) => headerCase(input);
/**
 * Transform into a lower cased string with spaces between words.
 * ```
 * toNoCase("testString") //=> "test string"
 * ```
 **/
export const toNoCase = (input) => noCase(input);
/**
 * Transform into a lower cased string with dashes between words. Also known as param-case
 * ```
 * toKebabCase("test string") //=> "test-string"
 * ```
 **/
export const toKebabCase = (input) => paramCase(input);
/**
 * Transform into a string of capitalized words without separators.
 * ```
 * toPascalCase("test string") //=> "TestString"
 * ```
 **/
export const toPascalCase = (input) => pascalCase(input);
/**
 * Transform into a lower case string with slashes between words.
 * ```
 * toPathCase("test string") //=> "test/string"
 * ```
 **/
export const toPathCase = (input) => pathCase(input);
/**
 * Transform into a lower case with spaces between words, then capitalize the string.
 * ```
 * toSentenceCase("testString") //=> "Test string"
 * ```
 **/
export const toSentenceCase = (input) => sentenceCase(input);
/**
 * Transform into a lower case string with underscores between words.
 * ```
 * toSnakeCase("test string") //=> "Test string"
 * ```
 **/
export const toSnakeCase = (input) => snakeCase(input);
/**
 * Transform into a lower case string with underscores between words.
 * ```
 * toTitleCase("test string") //=> "Test string"
 * toTitleCase("string"); //=> "String"
 * toTitleCase("follow step-by-step instructions"); //=> "Follow Step-by-Step Instructions"
 * ```
 **/
export const toTitleCase = (input) => titleCase(input !== null && input !== void 0 ? input : '' /* nullish as empty string for backwards compatibility */);
//# sourceMappingURL=change-case.js.map